import { createApp } from 'vue'
import { createPinia } from 'pinia';
import { createI18n } from 'vue-i18n';
import App from '@/App.vue'
import { version } from '../package.json';

console.log(`Aliaxis Showroom - Version ${version} Starting...`);
console.log("");

// Create App
let app = createApp(App);

const pinia = createPinia()
app.use(pinia)

const i18n = createI18n({
  legacy: false,
  locale: 'en', // default locale will be overwritten by the products.json
  fallbackLocale: 'en',
  messages: {},
  missingWarn: false, // Set to false to disable console logs for missing translations
  fallbackWarn: false, // Set to false to disable console logs for missing fallback translations
});

app.use(i18n);

app.mount('#app');